/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IState } from 'shared/interfaces/state.interface';
import { TPaginationRequest } from 'shared/types';
import { initialStore } from '../initial-store';

const journeyTemplateSlice = createSlice({
  name: 'journeyTemplate',
  initialState: initialStore.journeyTemplate,
  reducers: {
    setJourneyTemplateData: (state, { payload }) => {
      state.dataJourneyTemplates = payload?.data?.result || [];
      state.count = payload?.data?.count || 0;
      state.isLoading = false;
    },
    getJourneyTemplateData: (
      state,
      data: PayloadAction<TPaginationRequest | undefined>
    ) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    createJourneyTemplateData: (state, { payload }) => {
      state.isLoading = true;
    },
    actionFail: (state) => {
      state.isLoading = false;
    },
    buildJourneyTemplatePage: (state, { payload }) => {
      state.isLoading = true;
    },
    updateJourneyTemplateData: (state, { payload }) => {
      if (!state.isLoading) {
        state.dataIndividualJourneyTemplate.isLoadingUpdate = true;
      }
    },
    updateJourneyTemplateSuccess: (state, { payload }) => {
      state.dataIndividualJourneyTemplate.data = payload;
      state.dataIndividualJourneyTemplate.isLoadingUpdate = false;
    },
    updateJourneyTemplateFail: (state) => {
      state.dataIndividualJourneyTemplate.isLoadingUpdate = false;
    },

    setIndividualJourneyTemplateInfo: (state, { payload }) => {
      const data = payload;
      state.dataIndividualJourneyTemplate.data = {
        ...data
      };
      state.isLoading = false;
    },
    setJourneyTemplate: (state, { payload }) => {
      state.dataIndividualJourneyTemplate.data = {
        ...payload
      };
      state.isLoading = false;
    }
  }
});

export const {
  setJourneyTemplateData,
  getJourneyTemplateData,
  createJourneyTemplateData,
  actionFail,
  buildJourneyTemplatePage,
  setIndividualJourneyTemplateInfo,
  updateJourneyTemplateFail,
  updateJourneyTemplateData,
  updateJourneyTemplateSuccess,
  setJourneyTemplate
} = journeyTemplateSlice.actions;

export const { reducer } = journeyTemplateSlice;

// Selectors
export const getJourneyTemplatesSelector = (state: IState) => {
  return state && state?.journeyTemplate?.dataJourneyTemplates;
};

export const getJourneyTemplatesLoadingSelector = (state: IState) =>
  state && state?.journeyTemplate?.isLoading;

export const getJourneyTemplatesLoadingUpdateSelector = (state: IState) =>
  state &&
  state?.journeyTemplate?.dataIndividualJourneyTemplate?.isLoadingUpdate;

export const getJourneyTemplateIndividualSelector = (state: IState) =>
  state && {
    data: state.journeyTemplate.dataIndividualJourneyTemplate.data
  };

export const getJourneyTemplateCount = (state: IState) =>
  state && state?.journeyTemplate?.count;
